import { useState, useEffect,useRef } from "react";
import { useParams } from "react-router-dom";
import React from 'react';
import {
  Badge,
  Button,
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Col,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
} from "reactstrap";
import { toast } from 'react-toastify';
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "../../assets/css/custom.css";
import Header from "components/Headers/Header.js";
import { clientmanageService } from "../../services/clientmanageService.js";
import 'assets/css/themecustom-style.css';
import Select from 'react-select';
const axios = require("axios");
import jsPDF from "jspdf";
import "jspdf-autotable";

const EditInternalCall = (props) => {
  
  const [clientdata, setClientdata] = useState([]);
  const [clientsearch, setclientsearch] = useState([{'label':'All Clients',value:'al_key_1'}]);
  const [disablestate, setdisablestate] = useState(false);
  const [userclientlist, setusersclientlist] = useState({'users':''});
  const [disablestatebtn, setdisablestatebtn] = useState(false);

useEffect(() => {

  get_user_client_list();
  getsingledata();
  get_user_list();
}, []);

const months = [{value:'1',label : 'January'},{value:'2',label :'February'},{value:'3',label :'March'},{value:'4',label :'April'},{value:'5',label :'May'},{value:'6',label :'June'},{value:'7',label :'July'},{value:'8',label :'August'},{value:'9',label :'September'},{value:10,label :'October'},{value:11,label :'November'},{value:12,label :'December'}];
const [monthdata, setmonthdata] = useState(months);
let { id } = useParams();


function get_user_client_list(){
  clientmanageService.getusersclientlist().then((response)=>{
    setusersclientlist(response.data.users);
  });
}
const ratings = [
  { value: '5', label: 'Very Happy' },
  { value: '4', label: 'Happy' },
  { value: '3', label: 'Neutral' },
  { value: '2', label: 'Not Happy' },
  { value: '1', label: 'Unhappy' },
];

const getRatingLabel = (ratingValue) => {
  const selectedRating = ratings.find(rating => rating.value == ratingValue);
  return selectedRating ? selectedRating.label : '';
};


const initialData = {
  client_id : '',
  month : '',
  action_items : [],
  notes : [],
  client_attendees : [],
  corient_attendees : []
}
const [inputFields, setInputfields] = useState(initialData);
const [selectedbox,setselectedbox] = useState([]);
const [userlistData, setUserListData] = useState([]);
function get_user_list(){
    clientmanageService.getusers().then((response) => {
    setUserListData(response.data.users)
  });
}
function getsingledata(){
  clientmanageService.getinternalcall(id).then((response) => {
    console.log(response.data.data)
    setInputfields(response.data.data)
    setRateBox(response.data.data.action_items.length)
    setOriginalRateBox(response.data.data.action_items.length)
    setNoteBox(response.data.data.notes.length)
    setCorientBox(response.data.data.corient_attendees.length)
    setClientBox(response.data.data.client_attendees.length)
    setselectedbox(response.data.data.corient_attendees)
   
  })
}
console.log(inputFields)
 function inputhandler1(e,field) {
  setInputfields((prevInputFields) => ({
    ...prevInputFields,
    [field]: e.value,
  }));

}
function inputhandler(e) {
  let phseup = {}
  phseup = { ...inputFields, [e.target.name]: e.target.value }    
  setInputfields(phseup);
}
  function setclient(e){ 
    setclientsearch(e.label);
    setClientdata([]);
    setInputfields((prevInputFields) => ({
      ...prevInputFields,
      ['client_id']: e.value,
    }));
   
  }

  const [ratebox, setRateBox] = useState(0);
  const [originalratebox, setOriginalRateBox] = useState(0);
  const addRatebox = ()=>{
    const setdata = ratebox+1;
    setRateBox(setdata)
   
  }
  const removeRatebox = ()=>{
    if(ratebox > 0){
      const setdata = ratebox-1;
      setRateBox(setdata)
    }
  }
  const [notebox, setNoteBox] = useState(0);
 
  const addNotebox = ()=>{
    const setdata = notebox+1;
    setNoteBox(setdata)
   
  }
  const removeNotebox = ()=>{
    if(notebox > 0){
      const setdata = notebox-1;
      setNoteBox(setdata)
    }
  }
  const [corientbox, setCorientBox] = useState(0);
  const [label_disp_client, setlableclient] = useState(true);
 
  const addCorientbox = ()=>{
    const setdata = corientbox+1;
    setCorientBox(setdata)
   
  }
  const removeCorientbox = ()=>{
    if(corientbox > 0){
      const setdata = corientbox-1;
      setCorientBox(setdata)
    }
  }
  
  function inputcorienthandler(e, index) {
    const { name, value } = e.target;
    const corient_attendees = [...inputFields.corient_attendees];
    if (!corient_attendees[index]) {
      corient_attendees[index] = {}; // Initialize the user object if it doesn't exist
    }
    corient_attendees[index] = value;
    setInputfields({ ...inputFields, corient_attendees });
  }

  const [clientbox, setClientBox] = useState(0);
 
  const addClientbox = ()=>{
    const setdata = clientbox+1;
    setClientBox(setdata)
   
  }
  const removeClientbox = ()=>{
    if(clientbox > 0){
      const setdata = clientbox-1;
      setClientBox(setdata)
    }
  }
  
  function inputclienthandler(e, index) {
    const { name, value } = e.target;
    const client_attendees = [...inputFields.client_attendees];
    if (!client_attendees[index]) {
      client_attendees[index] = {}; // Initialize the user object if it doesn't exist
    }
    client_attendees[index] = value;
    setInputfields({ ...inputFields, client_attendees });
    setlableclient(false);
  }

  function inputactionhandler(e, index) {
    const { name, value } = e.target;
    const action_items = [...inputFields.action_items];
    if (!action_items[index]) {
      action_items[index] = {}; // Initialize the user object if it doesn't exist
    }
    action_items[index][name] = value;
    setInputfields({ ...inputFields, action_items });
  }
  function inputnotehandler(e, index) {
    const { name, value } = e.target;
    const notes = [...inputFields.notes];
    if (!notes[index]) {
      notes[index] = {}; // Initialize the user object if it doesn't exist
    }
    notes[index][name] = value;
    setInputfields({ ...inputFields, notes });
  }
  const [item_vali, setItemVali] = useState([]);
  const validateItems = () => {
  if (inputFields.action_items.length > 0) {
    const errors = inputFields.action_items.map((item) => {
      return {
      remarks: item.remarks === '' || item.remarks === undefined,
      responsibility: item.responsibility === '' || item.responsibility === undefined,
      action_item: item.action_item === '' || item.action_item === undefined,
      target_date: item.target_date === '' || item.target_date === undefined,
    };

    });

    setItemVali(errors);

    const hasErrors = errors.some(err => Object.values(err).includes(true));

    if (hasErrors) {
      toast.error("Some fields are missing.");
    }

    return !hasErrors; 
  } else {
    toast.error("Action Item Required.");
    return false; 
  }
  };
  function editcall(e){
    let flag = e.target.value;
    e.preventDefault();
   if(validateItems()){
    if(flag==1){
      setdisablestatebtn(true)
    }else{
      setdisablestate(true)
    }
    
    clientmanageService.editinternaltransdata(inputFields,flag).then((response)=>{
      
      if(response.status == 200){
         toast.success(response.data.message); 
      }else{
        Object.entries(response.data).forEach(([field, errors]) => {
            errors.forEach(error => toast.error(`${error}`));
          });
      }
      
   
    if(flag==1){
      setdisablestatebtn(false)
    }else{
      setdisablestate(false)
    }
    });
  }
  }
  const getMonthName = (monthValue) => {
   
    const selectedMonth = months.find(month => month.value == monthValue);
    return selectedMonth ? selectedMonth.label : '';
  };
   // State for controlling PDF generation
   const [pdfData, setPdfData] = useState(null);

   // Function to handle PDF generation
   const generatePdf = () => {
    try {
      const doc = new jsPDF();
     // const selectedMonthName = getMonthName(inputFields.month);

    //   const selectedRatingLabel = getRatingLabel(inputFields.rating);
      // Add content to the PDF
      doc.text(`Internal Call month : ${inputFields.month}`, 20, 20);
  
      let currentHeight = 40; // Initial height for the first page
  
      // Function to add attendees to the PDF
      const addAttendeesToPdf = (attendees, sectionTitle) => {
        doc.text(sectionTitle, 20, currentHeight);
        currentHeight += 10;
  
        attendees.forEach((attendee, index) => {
          doc.text(`${index + 1}. ${attendee}`, 30, currentHeight);
          currentHeight += 10;
  
          // Check if adding another line will exceed the page height
          if (currentHeight + 10 > doc.internal.pageSize.height) {
            doc.addPage(); // Start a new page
            currentHeight = 20; // Reset the height for the new page
          }
        });
  
        currentHeight += 10; // Add extra space between sections
      };
  
      // Add Corient attendees
      addAttendeesToPdf(inputFields.corient_attendees, "Corient Attendees");
  
  
  
      // Add Action Items
      doc.text("Action Items", 20, currentHeight);
      currentHeight += 10;
      inputFields.action_items.forEach((item, index) => {
        doc.text(`${index + 1}. ${item.action_item}`, 30, currentHeight);
        // doc.text(`Responsibility: ${item.responsibility}`, 30, currentHeight + 10);
        // doc.text(`Target Date: ${item.target_date}`, 30, currentHeight + 20);
        // doc.text(`Remarks: ${item.remarks}`, 30, currentHeight + 30);
        currentHeight += 10;
  
        // Check if adding another line will exceed the page height
        if (currentHeight + 10 > doc.internal.pageSize.height) {
          doc.addPage(); // Start a new page
          currentHeight = 20; // Reset the height for the new page
        }
      });
  
      // Add Notes
      doc.text("Notes", 20, currentHeight);
      currentHeight += 10;
      inputFields.notes.forEach((step, index) => {
        doc.text(`${index + 1}. ${step.note}`, 30, currentHeight);
        currentHeight += 10;
  
        // Check if adding another line will exceed the page height
        if (currentHeight + 10 > doc.internal.pageSize.height) {
          doc.addPage(); // Start a new page
          currentHeight = 20; // Reset the height for the new page
        }
      });
  
      // Save the PDF
      // doc.save("minutes_of_meeting.pdf");
      // Get the raw PDF data
      const pdfData = doc.output('blob');

      // Create a Blob from the PDF data
      const pdfBlob = new Blob([pdfData], { type: 'application/pdf' });
  
      // Create a URL for the Blob
      const pdfUrl = URL.createObjectURL(pdfBlob);
  
      // Open the PDF in a new window
      window.open(pdfUrl, '_blank');
  
      // Open the print dialog
      // window.print();
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  };
  
  const selectedMonthName = getMonthName(inputFields.month);
  function inputactionresphandler(e, index){
   
    const action_items = [...inputFields.action_items];
    if (!action_items[index]) {
      action_items[index] = {}; // Initialize the user object if it doesn't exist
    }
    action_items[index]['responsibility'] = e.value;
    setInputfields({ ...inputFields, action_items });
  }
  return (
    <>
      <Header />
      <Container className="mt--7"  fluid>
    
        <Row className="mt-5">
       
          <div className="col" style={{padding:'0%'}}>
              
            <Card className="shadow">
            <Button
                      className="col-2 mt-2"
                      color="success"
                      onClick={generatePdf}
                    >
                      Generate PDF
                    </Button>
                    <br></br>
            <Form role="form" id="adduser-form" onSubmit={editcall}>
              <CardHeader className="border-0">
              <Row >
                
              <div className="col-xl-4 col-md-4 col-xs-12">
                    <FormGroup>
                        <label>Internal call Date : {inputFields.month}</label>
                      
                      </FormGroup> 
                      <label className="clientformtag"> Client : {inputFields.client_name}</label>
                    
                    </div>


                    
                  <div className="col-xl-4 col-md-2 col-xs-12">
                    <FormGroup>
                        <label>Department</label>
                        <select class="form-control" name="department" value={inputFields.department} onChange={(e) => inputhandler(e)} required>
                        <option value="">Select Department</option>
                        <option value="Domestic RMS">Domestic RMS</option>
                        <option value="Domestic Sekura">Domestic Sekura</option>
                        <option value="Domestic Karma">Domestic Karma</option>
                        <option value="Domestic HDFC">Domestic HDFC</option>
                        <option value="IT Services">IT Services</option>
                        <option value="SME">SME</option>
                        <option value="Year-End Accountants">Year-End Accountants</option>
                        <option value="Bookkeeping Accountants">Bookkeeping Accountants</option>
                        <option value="Payroll">Payroll</option>
                        <option value="HR Talent Acquisition">HR Talent Acquisition</option>
                        <option value="HR Operations">HR Operations</option>
                        <option value="UK - E2E Sales">UK - E2E Sales</option>
                        <option value="US Sales">US Sales</option>
                        <option value="UK Sales">UK Sales</option>
                        <option value="Digital Marketing">Digital Marketing</option>
                        <option value="Learning & Development Training">Learning & Development Training</option>
                              </select>
                      </FormGroup> 
                  </div>
                    <br></br>
                    <div className="col-xl-3 col-md-2 col-xs-12">
                    <FormGroup>
                        <label>Meeting Title</label>
                        <Input
                     placeholder="Meeting Title"
                     type="text"
                     name="meeting_title"
                     onChange={(e) => inputhandler(e)}
                     value={inputFields.meeting_title}
                     required
                   />
                      </FormGroup> 
                  </div>
                  <div className="col-xl-3 col-md-2 col-xs-12">
                                      <FormGroup>
                                          <label>Type</label>
                                          <select class="form-control" name="type" value={inputFields.type}  onChange={(e) => inputhandler(e)} required>
                                          <option value="Weekly">Weekly</option>
                                                  <option value="MOR">MOR</option>
                                                  
                                                </select>
                                        </FormGroup> 
                                    </div>
                  <div className="col-md-12">&nbsp;</div>
                  {(() => {
            const arr1 = [];
            for (let k = 0; k < corientbox; k++) {
                arr1.push(
                 <>
                    
                    <div className="col-md-3">
                       <FormGroup>
                       {/* <label>Level</label> */}
                       <div className="row">
                     
                  <div className="col-xl-10 col-md-12 col-xs-12">
                    <FormGroup>
                        <label>Name</label>
                        {(userclientlist && userclientlist.length > 0)?
                        <InputGroup className="input-group-alternative mb-3">
                            <select className="form-control" name="team_user" placeholder="User" value={inputFields.corient_attendees[k] ? inputFields.corient_attendees[k] : ''} onChange={(e) => inputcorienthandler(e, k)}>
                              <option key="user_1"  value="">Select user manager for reporting{inputFields.corient_attendees[k]}</option>
                              {userclientlist.map(team =>
                                  <option key={team.value} value={team.value} >{team.label}</option>
                              )}
                            </select>
                          </InputGroup>
                        
                        
                    //   <Select 
                    
                    //   className="input-group-alternative mb-3" 
                    //   name="name"
                    //   options={userclientlist['users']} // set list of the data
                    //   value={inputFields.corient_attendees[k] ? inputFields.corient_attendees[k] : ''}
                    //   searchable
                    //   onChange={(e) => inputcorienthandler(e, k)}
                    //   isClearable={false}
                    // />
                    
                          : null }
                      </FormGroup>      
                  </div>

                 
                    
                    <Col md="1">
        {k >= inputFields.corient_attendees.length && (
        <button
        type="button"
          className="btn btn-danger"
          onClick={() => removeCorientbox(k)}
        >
          <i className="fa fa-remove"></i>
        </button>
       )} 
    </Col>
                        </div>
                      </FormGroup>    
                    </div> 
                    </>
                );
            }
            return arr1;
            
        })()}
                    <Col md="12" style={{marginBottom:"10px"}}>
            <a className="btn btn-info"  onClick={(e) => addCorientbox()}>+ Add Corient Attendees </a>
          </Col>
               

                    {/* <Col md="12" style={{marginBottom:"10px"}}>
            <a className="btn btn-info"  onClick={(e) => addClientbox()}>+ Add Client Attendees </a>
          </Col> */}
               
               <br></br>
                  <div className="col-md-12">&nbsp;</div>
                  {/* {(() => {
            const arr1 = [];
            for (let k = 0; k < clientbox; k++) {
                arr1.push(
                 <>
                    
                    <div className="col-md-3">
                       <FormGroup>
                      
                       <div className="row">
                     
                  <div className="col-xl-10 col-md-12 col-xs-12">
                    <FormGroup>
                        <label>Name</label>
                        <div className="d-flex">
                        { <InputGroup className="input-group-alternative mb-3">
                          <Input
                            placeholder="Name"
                            type="text"
                            name="name"
                            value={inputFields.client_attendees[k] ? inputFields.client_attendees[k] : ''}
                            onChange={(e) => inputclienthandler(e, k)}
                            required
                          />
                        </InputGroup> }
                                                  </div>
                      </FormGroup>      
                  </div>

                 
                    
                    <Col md="1">
      {k >= inputFields.client_attendees.length && (
        <button
        type="button"
          className="btn btn-danger"
          onClick={() => removeClientbox(k)}
        >
          <i className="fa fa-remove"></i>
        </button>
       )}
    </Col>
                        </div>
                      </FormGroup>    
                    </div> 
                    </>
                );
            }
            return arr1;
            
        })()}
                    <Col md="12" style={{marginBottom:"10px"}}>
            <a className="btn btn-info"  onClick={(e) => addClientbox()}>+ Add Client Attendees </a>
          </Col> */}

          <br></br>
                  {(() => {
            const arr1 = [];
            for (let k = 0; k < ratebox; k++) {
                arr1.push(
                 <>
                    
                    <div className="col-md-12">
                       <FormGroup>
                       {/* <label>Level</label> */}
                       <div className="row">
                       <div className="col-xl-3 col-md-2 col-xs-12">
                       <FormGroup>
                        <label>Feedback</label>
                        <InputGroup className="input-group-alternative mb-3">
                          <Input
                            placeholder="Feedback"
                            type="text"
                            name="remarks"
                            defaultValue={inputFields.action_items[k] ? inputFields.action_items[k].remarks : ''}
                            onChange={(e) => inputactionhandler(e, k)}
                            className={item_vali[k]?.remarks ? 'input-error' : ''}
                          />
                        </InputGroup>
                      </FormGroup> 
                     
                  </div>
                  <div className="col-xl-3 col-md-2 col-xs-12">
                    <FormGroup>
                        <label>Responsibility</label>
                        {(k <= originalratebox) && (inputFields.action_items[k]?.responsibility_check) ?
                        <Input
                            placeholder="Responsibility"
                            type="text"
                            name="responsibility"
                            defaultValue={inputFields.action_items[k] ? inputFields.action_items[k].responsibility : ''}
                            onChange={(e) => inputactionhandler(e, k)}
                            className={item_vali[k]?.responsibility ? 'input-error' : ''}
                          />
                          :
                        (userlistData.length > 0)?
                    // <select  class="form-control" name="responsibility" value={inputFields.action_items[k] ? inputFields.action_items[k].responsibility : ''}
                    // onChange={(e) => inputactionhandler(e, k)} >
                    // <option value=""> Select User</option>
                    // {(userlistData).map((valuel,k) =>
                    //               <option key={k} value={valuel.value}>
                    //                 {valuel.label}
                    //               </option>
                    //           )}
                    // </select>
                    <Select 
                    
                    className={
                            "input-group-alternative mb-3" +
                            (item_vali[k]?.responsibility ? " input-error" : "")
                          } 
                    name="responsibility"
                    options={userlistData} // set list of the data
                    value={userlistData.find(obj => obj.value === inputFields.action_items[k]?.responsibility) || ''} // set selected values
                    searchable
                    onChange={(e) => inputactionresphandler(e, k)}
                    isClearable={false}
                  />
                        : null }
                      </FormGroup> 
                  </div>
                  <div className="col-xl-2 col-md-2 col-xs-12">
                    <FormGroup>
                        <label>Target date</label>
                        <InputGroup className="input-group-alternative mb-3">
                          <Input
                            placeholder="Target date"
                            type="date"
                            name="target_date"
                            defaultValue={inputFields.action_items[k] ? inputFields.action_items[k].target_date : ''}
                            onChange={(e) => inputactionhandler(e, k)}
                            className={item_vali[k]?.target_date ? 'input-error' : ''}
                          />
                        </InputGroup>
                      </FormGroup> 
                  </div>
                       
                  <div className="col-xl-3 col-md-2 col-xs-12">
                  <FormGroup>
                        <label>Action Item</label>
                        <InputGroup className="input-group-alternative mb-3">
                          <Input
                            placeholder="Action Item"
                            type="text"
                            name="action_item"
                            defaultValue={inputFields.action_items[k] ? inputFields.action_items[k].action_item : ''}
                            onChange={(e) => inputactionhandler(e, k)}
                            className={item_vali[k]?.action_item ? 'input-error' : ''}
                          />
                        </InputGroup>
                      </FormGroup>  
                  </div>

                 
                    
                    <Col md="1">
                    <br></br>
        {k >= inputFields.action_items.length && (
        <button
        type="button"
          className="btn btn-danger"
          onClick={() => removeRatebox(k)}
        >
          <i className="fa fa-remove"></i>
        </button>
       )} 
    </Col>
                        </div>
                      </FormGroup>    
                    </div> 
                    </>
                );
            }
            return arr1;
            
        })()}
                    <Col md="12" style={{marginBottom:"10px"}}>
            <a className="btn btn-info"  onClick={(e) => addRatebox()}>+ Add action items </a>
          </Col>

          <br></br>
                  {/* <div className="col-md-12">&nbsp;</div>
                  {(() => {
            const arr1 = [];
            for (let k = 0; k < notebox; k++) {
                arr1.push(
                 <>
                    
                    <div className="col-md-12">
                       <FormGroup>
                     
                       <div className="row">
                     
                  <div className="col-xl-10 col-md-12 col-xs-12">
                    <FormGroup>
                      
                        <InputGroup className="input-group-alternative mb-3">
                          <Input
                            placeholder="Note"
                            type="textarea"
                            name="note"
                            defaultValue={inputFields.notes[k] ? inputFields.notes[k].note : ''}
                            onChange={(e) => inputnotehandler(e, k)}
                            required
                          />
                        </InputGroup>
                      </FormGroup>      
                  </div>

                 
                    
                    <Col md="1"><br></br>
        {k >= inputFields.notes.length && (
        <button
        type="button"
          className="btn btn-danger"
          onClick={() => removeNotebox(k)}
        >
          <i className="fa fa-remove"></i>
        </button>
      )} 
    </Col>
                        </div>
                      </FormGroup>    
                    </div> 
                    </>
                );
            }
            return arr1;
            
        })()}
                    <Col md="12" style={{marginBottom:"10px"}}>
            <a className="btn btn-info"  onClick={(e) => addNotebox()}>+ Add Notes </a>
          </Col> */}
               
                </Row>

                
                <div className="col-md-12">
                        <label>&nbsp;</label>
                        <Button className="col-1 " color="primary" value={0} onClick={(e) => editcall(e)} disabled={disablestate}>
                          {disablestate ? 'Sending...' : 'Save'} 
                         </Button>
                         <Button className="col-3" color="primary" type="submit" value={1} onClick={(e) => editcall(e)} disabled={disablestatebtn}>
                                                   {disablestatebtn ? 'Sending...' : 'Save & Send Mail to corient Attendees'} 
                                                   </Button>
                       
                    </div>
                    
              </CardHeader>
              </Form>
             </Card>
             </div>
             
        </Row>
      </Container>
    </>
  );
};


export default EditInternalCall;
